import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import TabsComponent from "../../../components/widgets/tabsComponent";
import ReachImageList from "./reachImageList";
import companyData from '../../../assets/data/company.json';
import IconComponent from '../../../components/icons/IconComponent';
import ClientsIcon from '../../../assets/icons/clients.svg';
import CountriesIcon from '../../../assets/icons/countries.svg';
import IndustriesIcon from '../../../assets/icons/industries.svg';
import DotGrid from "../../../components/animation/dotGrid/dotGrid";

const ReachLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    position: 'relative'
                }}
            >
                <div 
                    style={{ 
                        width: '100%', 
                        height: isMdUp ? '90%' : '100%',
                        position: 'absolute'
                    }}
                >
                    <DotGrid
                        dotSize={1}
                        gap={15}
                        baseColor={theme.palette.text.primary}
                        activeColor={theme.palette.text.secondary}
                        proximity={100}
                        shockRadius={250}
                        shockStrength={5}
                        resistance={750}
                        returnDuration={1.5}
                    />
                </div>

                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                    pt={{xs: 5, md: 5}}
                >
                    <TitleComponent 
                        title={t('reach.title')}
                        description={t('reach.description')}
                        centerMode
                    />

                    <TabsComponent 
                        list={[
                            {
                                label: t('reach.tabs.clients'), 
                                icon: <IconComponent icon={ClientsIcon} alt={t('reach.tabs.clients')}/>, 
                                children: <ReachImageList 
                                    list={companyData.reach.clients} 
                                    needGrayScale={false}
                                />
                            },
                            {
                                label: t('reach.tabs.countries'), 
                                icon: <IconComponent icon={CountriesIcon} alt={t('reach.tabs.countries')}/>, 
                                children: <ReachImageList 
                                    list={companyData.reach.countries} 
                                    needGrayScale={false}
                                    showLabels
                                />
                            },
                            {
                                label: t('reach.tabs.industries'), 
                                icon: <IconComponent icon={IndustriesIcon} alt={t('reach.tabs.industries')}/>, 
                                children: <ReachImageList 
                                    list={companyData.reach.industries} 
                                    needGrayScale={false}
                                    showLabels
                                />
                            }
                        ]}
                    />
                </Stack>
            </Box>
        </>
    );
}

export default ReachLayout;